import { httpStatus } from "@utils/errors";
import Header from "@layouts/Landing/components/Header";
import { useQueryClient } from "@tanstack/react-query";
import { ReactNode, useEffect, useState } from "react";
import ServiceWorks from "./ServiceWorks";

interface ErrorBoundaryRouteProps {
  children?: ReactNode;
  defaultOpen?: boolean;
}

const ErrorBoundaryRoute = ({
  children,
  defaultOpen = false,
}: ErrorBoundaryRouteProps) => {
  const [showBanner, setShowBanner] = useState(defaultOpen);
  const queryClient = useQueryClient();

  // React Query v5 removed defaultOptions.queries.onError.
  // Use QueryCache subscription to detect 503 errors.
  useEffect(() => {
    const cache = queryClient.getQueryCache();
    const unsubscribe = cache.subscribe(event => {
      if (event.type === "updated" && event.action?.type === "error") {
        if (httpStatus(event.action?.error) === 503) setShowBanner(true);
      }
    });
    return () => unsubscribe();
  }, [queryClient]);

  if (showBanner)
    return (
      <>
        <Header />
        <ServiceWorks />
      </>
    );

  return <>{children}</>;
};

export default ErrorBoundaryRoute;
